import { Model } from "@tailflow/laravel-orion/lib/model";

export class Designation extends Model<{
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}> {
  public $resource(): string {
    return "designations";
  }
}
